// @flow

export default function castArray(input?: any): Array<any> {
  if (Array.isArray(input)) {
    return input
  }

  if (arguments.length >= 0) {
    return [input]
  }

  return []
}
